import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "block text-center text-info-100 fs-15px fw-500 q-mb-12"
}
const _hoisted_2 = {
  key: 1,
  class: "block text-center text-error-100 fs-15px fw-500 q-mb-12"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]

import type { RouteLocationRaw } from 'vue-router'

interface IProps {
  illustration?: string
  title?: string
  description?: string
  to?: RouteLocationRaw
  btnText?: string
  btnIcon?: string
  error?: boolean
  errorTitle?: string
  errorDescription?: string
  errorIllustration?: string
  icon?: string
  rootClass?: string
}

type Emits = { 'click:button': [clicked: boolean] }


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'EmptyListAlert' },
  __name: 'EmptyListAlert',
  props: {
    illustration: { default: '' },
    title: { default: '' },
    description: { default: '' },
    to: { default: '' },
    btnText: { default: '' },
    btnIcon: { default: '' },
    error: { type: Boolean, default: false },
    errorTitle: { default: '' },
    errorDescription: { default: '' },
    errorIllustration: { default: '' },
    icon: { default: '' },
    rootClass: { default: 'q-px-xl q-py-56' }
  },
  emits: ["click:button"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_k_icon = _resolveComponent("k-icon")!
  const _component_k_btn = _resolveComponent("k-btn")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["EmptyListAlert non-selectable flex column items-center", [__props.rootClass]])
  }, [
    _renderSlot(_ctx.$slots, "icon", {}, () => [
      (!__props.error && __props.illustration !== '')
        ? (_openBlock(), _createBlock(_component_q_img, {
            key: 0,
            src: __props.illustration,
            class: "EmptyListAlert__illustration q-mb-xl",
            width: "80px"
          }, null, 8, ["src"]))
        : (__props.error && __props.errorIllustration !== '')
          ? (_openBlock(), _createBlock(_component_q_img, {
              key: 1,
              src: __props.errorIllustration,
              class: "EmptyListAlert__illustration q-mb-xl",
              width: "80px"
            }, null, 8, ["src"]))
          : _createCommentVNode("", true),
      (__props.icon)
        ? (_openBlock(), _createBlock(_component_k_icon, {
            key: 2,
            name: __props.icon,
            size: "80px",
            class: "q-mb-xl"
          }, null, 8, ["name"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      (!__props.error)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(__props.title), 1))
        : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.errorTitle), 1)),
      (!__props.error && __props.description !== '')
        ? (_openBlock(), _createElementBlock("span", {
            key: 2,
            class: _normalizeClass(["block text-center text-cool-gray-60 fs-15px", { 'q-mb-xl': __props.btnText }]),
            innerHTML: __props.description
          }, null, 10, _hoisted_3))
        : _createCommentVNode("", true),
      (__props.error && __props.errorDescription !== '')
        ? (_openBlock(), _createElementBlock("span", {
            key: 3,
            class: _normalizeClass(["block text-center text-cool-gray-60 fs-15px", { 'q-mb-xl': __props.btnText }]),
            innerHTML: __props.errorDescription
          }, null, 10, _hoisted_4))
        : _createCommentVNode("", true)
    ]),
    _renderSlot(_ctx.$slots, "button", {}, () => [
      (!__props.error && __props.btnText !== '')
        ? (_openBlock(), _createBlock(_component_k_btn, {
            key: 0,
            icon: __props.btnIcon ? __props.btnIcon : null,
            to: __props.to ? __props.to : null,
            "icon-size": __props.btnIcon === 'plus-rounded' ? '32px' : '24px',
            model: "secondary",
            size: "md",
            class: _normalizeClass([__props.btnIcon === 'plus-rounded' ? 'q-pr-lg q-pl-sm q-py-sm' : 'q-px-lg q-py-12']),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click:button', true)))
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                class: _normalizeClass(["fs-15px", __props.btnIcon ? 'q-ml-sm' : ''])
              }, _toDisplayString(__props.btnText), 3)
            ]),
            _: 1
          }, 8, ["icon", "to", "icon-size", "class"]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})